export default __webpack_public_path__ + "static/media/SwamijiNew7.0326f249.JPG";